import DdSubHeader from '@/components/DdSubHeader'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdDataTable from '@/components/DdDataTable'
import DdFooterButton from '@/components/DdFooterButton'
import DdHacchuKensakuTextBox from '@/components/DdHacchuKensakuTextBox'

import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import validators from '@/rahmen/validators'
import date from '@/ddv2.library/date'

import header from '@/ddv2.library/header'

export default {
  name: 'RcoJuchuList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      juchuEigyoshoCd: '',
      juchuStartYmdString: '',
      juchuEndYmdString: '',
      nyuryokuTantoshaCd: '',
      tokuisakiCd: '',
      sagyoYoteiStartYmdString: '',
      sagyoYoteiEndYmdString: '',
      chumonNo: '',
      sagyoNo: '',
      hacchuNo: '',
      ninushiCd: '',
      hatsuchiCd: '',
      oroshisakiCd: '',
      chakuchiCd: '',
      juchuStatusGroup: '',
      seikyuStatus: ''
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdCodeTextBox,
    DdDateBox,
    DdHacchuKensakuTextBox,
    DdTextBox,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdDataTable,
    DdFooterButton
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuYmd = filter.dateFormatter(elem.juchuYmd)
        if (elem.seikyuTomeFlg != null) { elem.seikyuTomeFlg = elem.seikyuTomeFlg ? '請求対象外' : '請求対象' }
        if (elem.ikkatsuSeikyuFlg != null) { elem.ikkatsuSeikyuFlg = elem.ikkatsuSeikyuFlg ? '一括請求' : '個別請求' }
        if (elem.seikyuYoteiYmd) { elem.seikyuYoteiYmd = filter.dateFormatter(elem.seikyuYoteiYmd) }
        if (elem.unchinKakuteiFlg != null) { elem.unchinKakuteiFlg = elem.unchinKakuteiFlg ? '確定' : '未確定' }
        if (elem.seikyuZumiFlg != null) { elem.seikyuZumiFlg = elem.seikyuZumiFlg ? '請求済み' : '未請求' }
        elem.seikyuKingaku = filter.numericFormatter(elem.seikyuKingaku) + '円'
        elem.juchuMeisaiKingaku = filter.numericFormatter(elem.juchuMeisaiKingaku) + '円'
        if (elem.sagyoYoteiYmd) { elem.sagyoYoteiYmd = filter.dateFormatter(elem.sagyoYoteiYmd) }
        if (elem.hatsuchiYmd) { elem.hatsuchiYmd = filter.dateFormatter(elem.hatsuchiYmd) }
        if (elem.hatsuchiHms) { elem.hatsuchiHms = (elem.hatsuchiHms).slice(0, 5) }
        if (elem.chakuchiYmd) { elem.chakuchiYmd = filter.dateFormatter(elem.chakuchiYmd) }
        if (elem.chakuchiHms) { elem.chakuchiHms = (elem.chakuchiHms).slice(0, 5) }
        if (elem.yoteiSagyoJikan) { elem.yoteiSagyoJikan = filter.minToTimeFormatter(elem.yoteiSagyoJikan) }
        if (elem.warimashiTaishoJikan) { elem.warimashiTaishoJikan = filter.minToTimeFormatter(elem.warimashiTaishoJikan) }
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) + '円' }
        if (elem.yoteiSokoKyori) { elem.yoteiSokoKyori = filter.numericFormatter(elem.yoteiSokoKyori) + 'km' }
        if (elem.warimashiTaishoKyori) { elem.warimashiTaishoKyori = filter.numericFormatter(elem.warimashiTaishoKyori) + 'km' }
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) + '円' }

        return elem
      })
    },
    filteredJuchuEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredNyuryokuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.jomuFlg = elem.jomuFlg ? '乗務員' : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filteredMstHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    CreateButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('RcoJuchuList.defineHeaderPromise')
            this.headers = [
              { text: '受注番号', value: 'juchuNo' },
              { text: '受注日', value: 'juchuYmd' },
              { text: '受注営業所', value: 'juchuEigyoshoNm' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '得意先', value: 'tokuisakiNm' },
              { text: '請求止', value: 'seikyuTomeFlg', align: 'center' },
              { text: '請求区分', value: 'ikkatsuSeikyuFlg', align: 'center' },
              { text: '請求予定日', value: 'seikyuYoteiYmd', align: 'center' },
              { text: '運賃確定状況', value: 'unchinKakuteiFlg', align: 'center' },
              { text: '請求状況', value: 'seikyuZumiFlg', align: 'center' },
              { text: '請求金額', value: 'seikyuKingaku', align: 'right', filterable: false },
              { text: '受注契約番号', value: 'juchuKeiyakuNo' },
              { text: '受注明細番号', value: 'juchuMeisaiNo' },
              { text: '受注明細金額', value: 'juchuMeisaiKingaku', align: 'right', filterable: false },
              { text: '作業希望日', value: 'sagyoYoteiYmd' },
              { text: '荷主', value: 'ninushiNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '発日付', value: 'hatsuchiYmd' },
              { text: '発時刻', value: 'hatsuchiHms' },
              { text: '発時刻備考', value: 'hatsuchiHmsBiko' },
              { text: '卸先', value: 'oroshisakiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '着日付', value: 'chakuchiYmd' },
              { text: '着時刻', value: 'chakuchiHms' },
              { text: '着時刻備考', value: 'chakuchiHmsBiko' },
              { text: '予定作業時間', value: 'yoteiSagyoJikan' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan' },
              { text: '割増時間単価', value: 'warimashiJikanTanka' },
              { text: '予定作業距離', value: 'yoteiSokoKyori' },
              { text: '割増対象距離', value: 'warimashiTaishoKyori' },
              { text: '割増距離単価', value: 'warimashiKyoriTanka' },
              { text: '作業明細', value: 'sagyoNo' },
              { text: '発注番号', value: 'hacchuNo' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            const d = new Date()
            self.conditions = {
              juchuEigyoshoCd: '',
              juchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              juchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              tokuisakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              sagyoNo: '',
              hacchuNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              juchuStatusGroup: '01',
              seikyuStatus: '01'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('RcoJuchuList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('RcoJuchuList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('RcoJuchuList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('RcoJuchuList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('RcoJuchuList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2rcod0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            juchuStatusGroup: self.conditions.juchuStatusGroup,
            seikyuStatus: self.conditions.seikyuStatus
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('RcoJuchuList.clearInputsPromise')
            const d = new Date()
            this.conditions = {
              juchuEigyoshoCd: '',
              juchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              juchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              tokuisakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              sagyoNo: '',
              hacchuNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              juchuStatusGroup: '01',
              seikyuStatus: '01'
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/VwCD2rcod0010/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (!this.conditions.juchuEigyoshoCd && !this.conditions.juchuStartYmdString && !this.conditions.juchuEndYmdString && !this.conditions.nyuryokuTantoshaCd && !this.conditions.tokuisakiCd && !this.conditions.sagyoYoteiStartYmdString && !this.conditions.sagyoYoteiEndYmdString && !this.conditions.chumonNo && !this.conditions.sagyoNo && !this.conditions.hacchuNo && !this.conditions.ninushiCd && !this.conditions.hatsuchiCd && !this.conditions.oroshisakiCd && !this.conditions.chakuchiCd && this.conditions.juchuStatusGroup === '01' && this.conditions.seikyuStatus === '01') {
        this.setInvalidSummaryMessage('COME0026')
        return false
      }
      if (this.conditions.juchuStartYmdString && this.conditions.juchuEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      if (this.conditions.sagyoYoteiStartYmdString && this.conditions.sagyoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
